import moment from 'moment';

import 'moment/dist/locale/ar';
import 'moment/dist/locale/de';
import 'moment/dist/locale/el';
import 'moment/dist/locale/es';
import 'moment/dist/locale/fi';
import 'moment/dist/locale/nl';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/sv';
import 'moment/dist/locale/tr';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/it';
import 'moment/dist/locale/fr';

class DateTimeFactoryCtrl {

    public create(args?: any): moment.Moment {
        return moment(args);
    }

    public async locale(lang: string) {
        moment.locale(
            this.isLocaleAvailable(lang)
                ? lang
                : 'en'
        );
    }

    public isLocaleAvailable(lang: string) {
        return ['ar', 'it', 'de', 'el', 'es', 'fi', 'fr', 'nl', 'pl', 'sv', 'tr', 'fr', 'pt'].includes(lang);
    }

}

export const DateTimeFactory = new DateTimeFactoryCtrl();